export const useUserStore = defineStore('user-store', {

  persist: true,

  state: () => {
    return {
      userId: null,
      userCountry: null,
      countryModal: false,
      countrySelected: false,
      //
      searchActive: false,
      //
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      utmTerm: null,
      utmContent: null,
      utmLandingPage: null,
      // Paid click ids captured at landing, sent with form submissions so the
      // server can fire GCLID/MSCLKID conversions. Persisted like UTMs.
      gclid: null,
      msclkid: null,
      // First-touch landing timestamp (ISO 8601), first_seen_at for the CRM.
      firstSeenAt: null,
      // First-touch external referrer (document.referrer at landing), sent to
      // the CRM as `referrer`. Captured once; kept through the session.
      referrer: null,
      //
      canWatch: false,
      heroTest: null,
    }
  },

  actions: {

    setUserCountry(country) {
      this.userCountry = country
    },

    setHeroTest(test) {
      this.heroTest = test
    },

    cookieSelection() {
      this.userCookieSelection = true
    },

    updateUtm(source, landingPage = null, medium = null, campaign = null, term = null, content = null) {
      this.utmSource = source
      this.utmMedium = medium
      this.utmCampaign = campaign
      this.utmTerm = term
      this.utmContent = content
      this.utmLandingPage = landingPage
    },

    // First-touch landing timestamp (ISO 8601). Set once; never overwritten, so
    // it reflects the visitor's original landing, not the latest visit.
    setFirstSeen() {
      if (!this.firstSeenAt) this.firstSeenAt = new Date().toISOString()
    },

    // First-touch external referrer. Set once so it reflects how the visitor
    // originally arrived, not an internal navigation. Empty referrer (direct)
    // is left null.
    setReferrer(referrer) {
      if (!this.referrer && referrer) this.referrer = referrer
    },

    // Capture paid click ids at landing. Only overwrite when a new one is
    // present, so we keep the first-touch click id through the session.
    setClickIds(gclid = null, msclkid = null) {
      if (gclid) this.gclid = gclid
      if (msclkid) this.msclkid = msclkid
    },

    storeUserId(id) {
      this.userId = id
    },

    closeSearch() {
      this.searchActive = false
    },
    openSearch() {
      this.searchActive = true
    },
    closeCountryModal() {
      this.countryModal = false
    },
    openCountryModal() {
      this.countryModal = true
    },
    selectCountry() {
      this.countryModal = false
      this.countrySelected = true
    }

  }
})


if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
